module.exports = __webpack_public_path__ + "img/user.345b8d42.png";